<template>
<div>
    <s-crud v-if="show == true" @doubleClick="doubleClick($event)" noBorder noDark searchInput title="Personas " :filter="filterGrid" :config="this.config">
    </s-crud>
</div>
</template>

<script>
import ServicePrs from "@/services/General/PersonService";
export default {
    name: "sSearchPerson",
    components: {},
    props: {
        typeperson: {
            type: Number,
            default: 0,
        },
    },
    data: () => ({
        show: false,
        filterGrid: {
            TypePerson: 1,
            SecStatus: 1
        },
        config: {
            model: {
                PrsID: "ID",
                PrsDocumentNumber: "string",
                PrsFullName: "string",
                TypePersonDocument: "int",
                SecStatus: "",
            },
            service: ServicePrs,
            headers: [{
                    text: "ID",
                    value: "PrsID"
                },
                {
                    text: "N°Documento",
                    value: "PrsDocumentNumber"
                },
                {
                    text: "Nombre",
                    value: "PrsFullName"
                },
            ],
        },
    }),
    methods: {
        doubleClick(item) {
            this.$emit("returnPerson", item);
        },
    },
    created() {
        this.config.typeperson = this.typeperson;
        this.show = true;
    },
};
</script>
